import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    CodeBlock,
    BlockType,
    TibboDataType,
    SettingState,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import * as tios from './tios';
import * as simulator from './simulator';

export default class ModbusDeviceRegister extends BaseFeature {
    constructor() {
        super();
        this.name = 'Modbus Device Register';
        this.id = 'modbus_device_register';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'ADDRESS',
                name: 'Start Address',
                helpText: 'Specify in base 10 or hex (0x)',
                settingType: SettingType.STRINGVARIABLE,
                dataType: TibboDataType.WORD,
                required: true,
                default: '1',
            },
            {
                id: 'LENGTH',
                name: 'Length (Number of registers)',
                settingType: SettingType.NUMBER,
                required: true,
                max: 2,
                default: '1',
            },
            {
                id: 'DATATYPE',
                name: 'Register Type',
                settingType: SettingType.OPTION,
                required: true,
                default: 'ReadCoilStatus',
                options: [
                    {
                        name: 'COIL/Output',
                        value: 'ReadCoilStatus',
                    },
                    {
                        name: 'Contact/Discrete Input',
                        value: 'ReadInputStatus',
                    },
                    {
                        name: 'Holding Register (offset from 40000)',
                        value: 'ReadHoldingRegisters',
                    },
                    {
                        name: 'Input Register (offset from 30000)',
                        value: 'ReadInputRegisters',
                    },
                ],
            },
            {
                id: 'VARTYPE',
                name: 'Value Type',
                settingType: SettingType.OPTION,
                required: true,
                default: 'INTEGER',
                options: [
                    {
                        name: 'Unsigned Integer',
                        value: 'INTEGER',
                    },
                    {
                        name: 'Signed Integer',
                        value: 'SIGNED_INTEGER',
                    },
                    {
                        name: 'Floating Point Number',
                        value: 'FLOAT',
                    },
                ],
            },
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'mod_reg_value',
            },
            {
                id: 'MULTIPLIER',
                name: 'Multiplier',
                settingType: SettingType.NUMBER,
                required: true,
                default: '1',
            },
            {
                id: 'ENDIAN',
                name: 'Endianness',
                settingType: SettingType.OPTION,
                required: true,
                default: 'BIG',
                options: [
                    {
                        name: 'Big Endian (ABCD)',
                        value: 'BIG',
                    },
                    {
                        name: 'Little Endian (CDAB)',
                        value: 'LITTLE',
                    },
                ],
            },
        ]);
    }

    getState(settingId: string): SettingState {
        const registerType = this.getSettingValue('DATATYPE');
        switch (settingId) {
            case 'VARTYPE':
                if (registerType === 'ReadHoldingRegisters' || registerType === 'ReadInputRegisters') {
                    return SettingState.ENABLED;
                }
                return SettingState.HIDDEN;
            default:
                return SettingState.ENABLED;
        }
    }

    initSettings(project?: any, parentFeature?: any): void {
        super.initSettings(project, parentFeature, 'NAME');
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
